import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polygon,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "4", y2: "20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polygon, { points: "10,4 20,12 10,20", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "StepForward";
const StepForward = memo(themed(Icon));
export {
  StepForward
};
//# sourceMappingURL=step-forward.js.map
